// @flow
import _debug from 'debug';
import { makeActionCreator, reduce } from '../helpers/utils';

const debug = _debug('jp:reducers:ui');

export const UPDATE_UI = 'ui:update';

export type State = {|
  headerShouldShowCTA: boolean,
  animateSearchForm: boolean
|};

export const initialState: State = {
  headerShouldShowCTA: false,
  animateSearchForm: false
};

type Action = {| type: typeof UPDATE_UI, data: any |};

export default reduce<State, Action>(initialState, {
  [UPDATE_UI](state: State, action: Action): State {
    debug(UPDATE_UI, action);

    return {
      ...state,
      ...action.data
    };
  }
});

export const updateUI = makeActionCreator(UPDATE_UI, 'data');
